import React from 'react';
import { StarIcon } from 'lucide-react';
import { pillars } from '../data/landing';
export function SkillsSection() {
  return <section className="w-full bg-white py-20 md:py-28" aria-labelledby="skills-title" data-id="element-243" data-mp="2zcfejhvp7z2a">
      <div className="mx-auto max-w-6xl px-5" data-id="element-244" data-mp="345i4lg19oqdq">
        <div className="mx-auto max-w-3xl text-center" data-id="element-245" data-mp="346t6tbf2dq2q">
          <p className="font-display text-2xl font-semibold leading-snug text-ink md:text-3xl" data-id="element-246" data-mp="384qwefcqye6n">
            100+ hands-on robotics projects they'll actually want to do — built with simple everyday materials, guided by easy step-by-step PDFs & videos.
          </p>
          <p className="mt-4 inline-flex items-center gap-2 text-base font-bold text-inkSoft" data-id="element-247" data-mp="2kfy7h2ujl6lj">
            <span className="flex gap-0.5" aria-label="Rated 5 out of 5" data-id="element-248" data-mp="2pfapnaagxphs">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-sun text-sun" aria-hidden data-id="element-249" data-mp="3vutimetzcpxc" data-mpi={i} />)}
            </span>
            1,250+ happy families transforming their homes
          </p>
        </div>

        <div className="mx-auto mt-20 max-w-3xl text-center" data-id="element-250" data-mp="3ovcfv19vooar">
          <h2 id="skills-title" className="font-display text-3xl font-bold leading-tight text-ink md:text-5xl" data-id="element-251" data-mp="3jw89eiec94o4">
            This isn't just a digital book
          </h2>
          <p className="mt-4 text-lg font-semibold text-inkSoft" data-id="element-252" data-mp="3ezhuvzi6mh4t">
            It's an interactive tool to cultivate critical skills that will stick with them for a lifetime:
          </p>
        </div>

        <ul className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-253" data-mp="35ytb0o63xmk0">
          {pillars.map(({
          icon: Icon,
          title,
          text,
          tone
        }) => <li key={title} className="flex flex-col items-center rounded-3xl bg-cream p-8 text-center" data-id="element-254" data-mp="2w6nmjof2dn9k">
              <span className={`flex h-16 w-16 items-center justify-center rounded-2xl ${tone}`} data-id="element-255" data-mp="2r8vki1kpgkrn">
                <Icon className="h-8 w-8" aria-hidden data-id="element-256" data-mp="2m9979s4vn4iu" />
              </span>
              <h3 className="mt-5 font-display text-2xl font-bold text-ink" data-id="element-257" data-mp="2i7e5kmj1ap4j">{title}</h3>
              <p className="mt-2 text-lg text-inkSoft" data-id="element-258" data-mp="2i9s2z216sdf9">{text}</p>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl text-center font-display text-2xl font-semibold leading-snug text-berry" data-id="element-259" data-mp="2cldnlpddwufs">
          This is your chance to connect and inspire, rather than just entertain.
        </p>
      </div>
    </section>;
}